import { twMerge } from "tailwind-merge";
import { Fragment } from "react";

const ToolboxItems = ({items, className, itemsWrapperClassName}) => {
    return (
        <div className={twMerge("flex [mask-image: linear-gradient(to_right , transparent, black_10%, black_90%, transparent)]", className)}>
            <div className={twMerge("flex flex-none py-0.5 gap-6 pr-6", itemsWrapperClassName)}>
                {[...new Array(2)].fill(0).map((_, idx) => (
                    <Fragment key={idx}>
                        {items.map(item => (
                            <div key={item.title} className="inline-flex bg-white/50 items-center gap-4 py-2 px-3 outline outline-2 outline-white/10 rounded-lg">
                                <img src={item.iconType} alt="" style={{width: 17, height:"auto"}} />
                                <span className="font-semibold text-sm sm:text-base">{item.title}</span>
                            </div>
                        ))}
                    </Fragment>
                ))}
            </div>
        </div>
    )
}
export default ToolboxItems